var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formName.errors.has(_vm.propName)
    ? _c("span", {
        staticClass: "text-danger",
        domProps: {
          textContent: _vm._s(_vm.formName.errors.get(_vm.propName)),
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }